import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaChevronLeft, FaChevronRight, FaWhatsapp } from 'react-icons/fa';
import styles from './flabernardi__procedimentos.module.scss';
import BrowLamination1 from './src/procedimentos/brow-lamination-1.png';
import BrowLamination2 from './src/procedimentos/brow-lamination-2.png';
import Henna from './src/procedimentos/henna.png';
import Noiva1 from './src/procedimentos/noiva-1.png';
import MaquiagemSocial1 from './src/procedimentos/maquiagem-social-1.png';
import Micropigmentacao1 from './src/procedimentos/micropigmentacao-1.png';
import Micropigmentacao2 from './src/procedimentos/micropigmentacao-2.png';

const WHATSAPP_NUMBER = '5517981381550';

type Procedimento = {
    titulo: string;
    descricao: string;
    imagens: string[];
    whatsappMessage: string;
};

const procedimentos: Procedimento[] = [
    {
        titulo: 'Brow Lamination',
        descricao:
            'Efeito lifting que eleva e valoriza o olhar\nFios alinhados, volumosos e sofisticados',
        imagens: [BrowLamination1, BrowLamination2],
        whatsappMessage:
            'Olá, gostaria de mais informações sobre Brow Lamination.',
    },
    {
        titulo: 'Henna',
        descricao:
            'Sobrancelhas desenhadas com precisão e naturalidade\nHarmonia e definição sob medida',
        imagens: [Henna],
        whatsappMessage: 'Olá, gostaria de mais informações sobre Henna.',
    },
    {
        titulo: 'Maquiagem De Noiva',
        descricao:
            'Beleza impecável para um dos dias mais especiais ✨\nPele ultra resistente, pensada para durar intacta',
        imagens: [Noiva1],
        whatsappMessage:
            'Olá, gostaria de mais informações sobre Maquiagem De Noiva.',
    },
    {
        titulo: 'Maquiagem Social',
        descricao:
            'Acabamento glow sofisticado e de longa duração\nBeleza realçada com leveza e elegância',
        imagens: [MaquiagemSocial1],
        whatsappMessage:
            'Olá, gostaria de mais informações sobre Maquiagem Social.',
    },
    {
        titulo: 'Micropigmentação',
        descricao:
            'Correção de falhas e definição com efeito natural duradouro\nResultado elegante e de longa duração',
        imagens: [Micropigmentacao1, Micropigmentacao2],
        whatsappMessage:
            'Olá, gostaria de mais informações sobre Micropigmentação.',
    },
];

const getWhatsappUrl = (message: string) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

interface CardProcedimentoProps {
    titulo: string;
    descricao: string;
    imagens: string[];
    whatsappMessage: string;
}

const CardProcedimento: React.FC<CardProcedimentoProps> = ({
    titulo,
    descricao,
    imagens,
    whatsappMessage,
}) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const hasMultipleImages = imagens.length > 1;

    const prevImage = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (!hasMultipleImages) return;
        setCurrentIndex((prev) => (prev === 0 ? imagens.length - 1 : prev - 1));
    };

    const nextImage = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (!hasMultipleImages) return;
        setCurrentIndex((prev) => (prev === imagens.length - 1 ? 0 : prev + 1));
    };

    return (
        <div className={styles.card}>
            <div className={styles.carouselContainer}>
                <img src={imagens[currentIndex]} alt={titulo} className={styles.carouselImage} />
                {hasMultipleImages && (
                    <>
                        <button
                            type="button"
                            className={`${styles.carouselBtn} ${styles.prevBtn}`}
                            onClick={prevImage}
                            aria-label="Imagem anterior"
                        >
                            <FaChevronLeft />
                        </button>
                        <button
                            type="button"
                            className={`${styles.carouselBtn} ${styles.nextBtn}`}
                            onClick={nextImage}
                            aria-label="Próxima imagem"
                        >
                            <FaChevronRight />
                        </button>
                        <div className={styles.indicators}>
                            {imagens.map((_, idx) => (
                                <span
                                    key={idx}
                                    role="button"
                                    tabIndex={0}
                                    className={`${styles.dot} ${idx === currentIndex ? styles.active : ''}`}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setCurrentIndex(idx);
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            setCurrentIndex(idx);
                                        }
                                    }}
                                    aria-label={`Ir para imagem ${idx + 1}`}
                                />
                            ))}
                        </div>
                    </>
                )}
            </div>

            <h3 className={styles.cardTitle}>{titulo}</h3>
            <p className={styles.descricao}>
                {descricao.split('\n').map((line, i) => (
                    <React.Fragment key={i}>
                        {i > 0 && <br />}
                        {line}
                    </React.Fragment>
                ))}
            </p>

            <a
                href={getWhatsappUrl(whatsappMessage)}
                className={styles.whatsappBtn}
                target="_blank"
                rel="noopener noreferrer"
            >
                <FaWhatsapp aria-hidden />
                <span>Falar no WhatsApp</span>
            </a>
        </div>
    );
};

const Flabernardi__procedimentos: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.flabernardi__procedimentos}>
            <div className={styles.header}>
                <Link
                    to="/flabernardi_"
                    state={{ skipLoader: true }}
                    className={styles.backButton}
                    aria-label="Voltar ao cartão digital"
                >
                    <FaArrowLeft />
                </Link>
                <h1 className={styles.pageTitle}>Procedimentos</h1>
            </div>

            <div className={styles.lista}>
                {procedimentos.map((item) => (
                    <CardProcedimento
                        key={item.titulo}
                        titulo={item.titulo}
                        descricao={item.descricao}
                        imagens={item.imagens}
                        whatsappMessage={item.whatsappMessage}
                    />
                ))}
            </div>
        </div>
    );
};

export default Flabernardi__procedimentos;
